import multiFilterComponent from '../../../core/components/filterable-grid/multi-filter-component';
import textFilterComponent from '../../../core/components/filterable-grid/text-filter-component';
import IsBannedModeratedComponent from './is-banned-moderated-component';
import { ActionRenderer, householdIncomeActionRenderer, numberActionRenderer } from './utils';

export const columnDefs = [
  {
    headerName: 'Email address',
    field: 'email',
    sortable: true,
    width: 270,
    cellRenderer: ActionRenderer,
    filter: textFilterComponent,
    type: 'text',
  },
  {
    headerName: 'First name',
    field: 'firstName',
    sortable: true,
    filter: textFilterComponent,
    type: 'text',
  },
  {
    headerName: 'Last name',
    field: 'lastName',
    hide: false,
    sortable: true,
    filter: textFilterComponent,
    type: 'text',
  },
  {
    headerName: 'Moderated',
    field: 'isBannedModeratedAt',
    cellRenderer: IsBannedModeratedComponent,
  },
  {
    headerName: 'Phone number',
    field: 'phoneNumber',
  },
  {
    headerName: 'Last Participated',
    field: 'lastParticipated',
  },
  {
    headerName: 'Last Emailed',
    field: 'lastEmailed',
    sortable: true,
  },
  {
    headerName: 'Last Invited',
    field: 'lastInvited',
  },
  {
    headerName: 'Last applied',
    field: 'lastApplied',
  },
  {
    headerName: 'Last Logged In',
    field: 'lastLoggedIn',
  },
  {
    headerName: 'User Status',
    field: 'status',
    sortable: true,
  },
  {
    headerName: 'Guest tester',
    field: 'guestTester',
  },
  {
    headerName: 'Rating',
    field: 'rating',
    cellRenderer: numberActionRenderer,
  },
  {
    headerName: 'Computer',
    field: 'computer',
  },
  {
    headerName: 'Phone',
    field: 'phone',
  },
  {
    headerName: 'Tablet',
    field: 'tablet',
  },
  {
    headerName: 'Age',
    field: 'age',
    cellRenderer: numberActionRenderer,
    filter: multiFilterComponent,
    type: 'multiOnJSONText',
    isSignupQuery: true,
    scope: 'users',
  },
  {
    headerName: 'Gender',
    field: 'gender',
    filter: multiFilterComponent,
    type: 'multiOnJSONText',
    isSignupQuery: true,
    scope: 'users',
  },
  {
    headerName: 'Ethnicity',
    field: 'ethnicity',
    filter: multiFilterComponent,
    type: 'multiOnJSONText',
    isSignupQuery: true,
    scope: 'users',
  },
  {
    headerName: 'Household Income',
    field: 'householdIncome',
    cellRenderer: householdIncomeActionRenderer,
    filter: multiFilterComponent,
    type: 'multiOnJSONText',
    isSignupQuery: true,
    collection: [
      '<$25,000',
      '$25,001-$50,000',
      '$50,001-$100,000',
      '$100,001-$150,000',
      '$150,001-$200,000',
      '>$200,001',
    ],
    scope: 'users',
  },
  {
    headerName: 'Country',
    field: 'country',
    filter: multiFilterComponent,
    type: 'multiOnJSONText',
    isSignupQuery: true,
    scope: 'users',
  },
  {
    headerName: 'State',
    field: 'state',
    filter: multiFilterComponent,
    type: 'multiOnJSONText',
    isSignupQuery: true,
    scope: 'users',
  },
  {
    headerName: 'Zipcode',
    field: 'zipcode',
  },
  {
    headerName: 'Language',
    field: 'language',
    filter: multiFilterComponent,
    type: 'multiOnJSONArr',
    isSignupQuery: true,
    scope: 'users',
  },
  {
    headerName: 'Job Title',
    field: 'jobTitle',
  },
  {
    headerName: 'Job Role',
    field: 'jobRole',
    filter: multiFilterComponent,
    type: 'multiOnJSONArr',
    isSignupQuery: true,
    scope: 'users',
  },
  {
    headerName: 'Current Work Status',
    field: 'currentWorkStatus',
    filter: multiFilterComponent,
    type: 'multiOnJSONText',
    isSignupQuery: true,
    collection: [
      'Full Time',
      'Part Time',
      'Business Owner',
      'Self-Employed / Contract / Freelance',
      'Unemployed',
      'Retired',
      'Homemaker',
      'Student',
    ],
    scope: 'users',
  },
  {
    headerName: 'Education',
    field: 'education',
  },
  {
    headerName: 'Company Size',
    field: 'companySize',
    filter: multiFilterComponent,
    type: 'multiOnJSONText',
    isSignupQuery: true,
    collection: [
      ['1'],
      ['1-10', '11-50'],
      ['51-200', '201-500', '501-1000'],
      ['1001-5000', '5001-10,000'],
      ['10,001+'],
    ],
    scope: 'users',
  },
  {
    headerName: 'Industry',
    field: 'industry',
    filter: multiFilterComponent,
    type: 'multiOnJSONText',
    isSignupQuery: true,
    scope: 'users',
  },
  {
    headerName: 'Seniority',
    field: 'seniority',
    filter: multiFilterComponent,
    type: 'multiOnJSONText',
    isSignupQuery: true,
    scope: 'users',
  },
  {
    headerName: 'Paypal address',
    field: 'paypalAddress',
  },
  {
    headerName: 'Number of tests the user has taken',
    field: 'testTaken',
    cellRenderer: numberActionRenderer,
  },
];

export const audienceToFilterMap = {
  location_state: 'state',
  location_country: 'country',
  work_status: 'currentWorkStatus',
  household_income: 'householdIncome',
  job_role: 'jobRole',
  company_size: 'companySize',
};
